import { render, staticRenderFns } from "./PDFView.vue?vue&type=template&id=4d8f05ee&scoped=true&"
import script from "./PDFView.vue?vue&type=script&lang=js&"
export * from "./PDFView.vue?vue&type=script&lang=js&"
import style0 from "./PDFView.vue?vue&type=style&index=0&id=4d8f05ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f05ee",
  null
  
)

export default component.exports